var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.841,
    height: 31.3,
    viewBox: "0 0 47.841 31.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-6618.979 -5783.703)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    x1: 47.841,
    transform: "translate(6618.979 5785.203)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    x1: 47.841,
    transform: "translate(6618.979 5799.353)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    x1: 47.841,
    transform: "translate(6618.979 5813.503)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHeader);
export default __webpack_public_path__ + "static/media/iconMenuHeader.01807a4ddc6f89d0a9e35184af5317ef.svg";
export { ForwardRef as ReactComponent };